import React, { Component } from 'react'
import PropTypes from 'prop-types'
import memoize from 'memoize-one'
import SearcheableList from './SearcheableList'

export default class SearcheableMutipleSelect extends Component {
  state = {
    search: '',
  }

  static propTypes = {
    items: PropTypes.array.isRequired,
    selectedValues: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    getValueFromItem: PropTypes.func.isRequired,
    filterItems: PropTypes.func.isRequired,
    renderRow: PropTypes.func.isRequired,
    inputProps: PropTypes.object.isRequired,
    itemsContainerProps: PropTypes.object.isRequired,
  }

  static defaultProps = {
    filterItems(items, term) {
      return items.filter(item => item.includes(term))
    },
    getValueFromItem(value) {
      return value
    },
    renderRow({ selected, item, onClick }) {
      return (
        <div onClick={onClick}>
          {selected ? '[x]' : '[ ]'} - {item}
        </div>
      )
    },
    inputProps: {},
    itemsContainerProps: {},
  }

  filter = memoize((items, search) => {
    const filteredItems = this.props.filterItems(items, search)
    const selectedItems = filteredItems.filter(item =>
      this.props.selectedValues.includes(this.props.getValueFromItem(item))
    )
    const unselectedItems = filteredItems.filter(
      item =>
        !this.props.selectedValues.includes(this.props.getValueFromItem(item))
    )
    return [...selectedItems, ...unselectedItems]
  })

  render() {
    return (
      <SearcheableList
        items={this.props.items}
        inputProps={this.props.inputProps}
        itemsContainerProps={this.props.itemsContainerProps}
        filterItems={this.filter}
        renderRow={this._renderRow}
      />
    )
  }

  _renderRow = ({ item }) => {
    const selected = this.props.selectedValues.find(
      value => value === this.props.getValueFromItem(item)
    )

    return this.props.renderRow({
      selected,
      item,
      onClick: () => this.onRowClicked(item),
    })
  }

  onRowClicked = item => {
    const itemValue = this.props.getValueFromItem(item)
    const wasSelected = this.props.selectedValues.find(
      value => value === itemValue
    )

    if (wasSelected) {
      this.props.onChange(
        this.props.selectedValues.filter(value => value !== itemValue)
      )
    } else {
      this.props.onChange([...this.props.selectedValues, itemValue])
    }
  }
}
